<div *ngIf="navigating" class="dh-route-bar" aria-hidden="true"></div>
<div *ngIf="envName && !navigating" class="dh-env-stripe" aria-hidden="true"></div>
<div *ngIf="offline" class="dh-offline" role="alert">Sin conexión con el servidor. Los cambios no se guardan hasta que vuelva.</div>
<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask"></div>
</div>
